"use client";

import { z } from "zod";

export const holidayCityListSchema = z.object({
  city_id: z.number(),
  city: z.string().optional(),
  country_name: z.string().optional(),
  lat: z.number().optional(),
  lng: z.number().optional(),
});

export const holidaySearchSchema = z.object({
  city: holidayCityListSchema.nullable().optional(),
});

export type IHolidaySearchSchema = z.infer<typeof holidaySearchSchema>;

export const defaultHolidayFormValue: IHolidaySearchSchema = {
  city: null,
};
